import React from 'react';
import ReaderTypeForm from './components/ReaderTypeForm';

const ReaderTypeCreatePage: React.FC = () => {
  return <ReaderTypeForm />;
};

export default ReaderTypeCreatePage;